export default function productController() {
  const productInfo = document.querySelector('product-info');
  const productForm = document.querySelector('.product-form');

  if (!productForm) {
    return;
  }

  const quantityInput = productForm.querySelector('input[name="quantity"]');
  const variantIdInput = productForm.querySelector('input[name="id"]');

  const buttonPrice = productForm.querySelector('.js-button-product-price');

  const simpleProductPrice = parseInt(productInfo.dataset.simpleProductPrice, 10) / 100 || 0;
  const priceByVariant = JSON.parse(productInfo.dataset.priceByVariant || '{}');
  const qtyHeading = productInfo.dataset.qtyHeading || null;

  const singularName = productInfo.dataset.singularName ? extractText(productInfo.dataset.singularName) : 'item';
  const pluralName = productInfo.dataset.pluralName ? extractText(productInfo.dataset.pluralName) : 'items';

  const predictedDiscount = productInfo.dataset.predictedDiscount;

  let productPrice = simpleProductPrice;
  let productQuantity = 1;
  let subscriptionDiscount = 0;
  let quantityDiscount = 0;

  // const subOriginalPriceItem = document.querySelector(
  //   '[data-selling-plan-type="subscription"] .subscription-box__option__prices .regular'
  // );
  // const subDiscountPriceItem = document.querySelector(
  //   '[data-selling-plan-type="subscription"] .subscription-box__option__prices .final'
  // );
  // const oneOriginalPriceItem = document.querySelector(
  //   '[data-selling-plan-type="one-time"] .subscription-box__option__prices .regular'
  // );
  // const oneDiscountPriceItem = document.querySelector(
  //   '[data-selling-plan-type="one-time"] .subscription-box__option__prices .final'
  // );

  const originalPriceItem = document.querySelector('.subscription-box__prices .regular');
  const finalPriceItem = document.querySelector('.subscription-box__prices .final');
  const pricePerItemItem = document.querySelector('.subscription-box__prices .per-item');
  const itemsInPackCount = ((document.querySelector('.product-price-per-item')?.dataset?.itemsInPackText || '').match(
    /\d+/
  ) || [])[0];

  function renderQuantitySelector() {
    const newContainer = document.getElementById('new-quantity-selector-container');

    if (!window.discountRules || !window.discountRules.length || !newContainer) {
      return;
    }

    const radioName = 'discount-quantity';
    const containerClass = 'discount-quantity';
    const labelClass = 'discount-quantity__label';
    const inputClass = 'discount-quantity__input';
    const textClass = 'discount-quantity__text';
    const discountClass = 'discount-quantity__discount';

    const container = document.createElement('div');
    container.classList.add(containerClass);

    window.discountRules.forEach((rate, index) => {
      const inputId = `discount-quantity-${index}`;

      const label = document.createElement('label');
      label.classList.add(labelClass, 'scroll-trigger', 'animate--fade-in');
      label.htmlFor = inputId;

      const input = document.createElement('input');
      input.classList.add(inputClass);
      input.type = 'radio';
      input.name = radioName;
      input.value = rate.min;
      input.checked = index === 0;
      input.id = inputId;
      input.classList.add('hidden');

      const text = document.createElement('span');
      text.classList.add(textClass);
      text.innerText = `${rate.min} ${pluralize(rate.min, singularName, pluralName)}`;

      const discount = document.createElement('span');
      discount.classList.add(discountClass);
      discount.innerText = `Save ${rate.discount * 100}%`;
      if (rate.discount === 0) {
        discount.classList.add('hidden');
      }

      label.appendChild(input);
      label.appendChild(text);
      label.appendChild(discount);

      container.appendChild(label);

      input.addEventListener('change', () => {
        const quantity = parseInt(input.value, 10);
        quantityInput.value = quantity;
        quantityDiscount = rate.discount;
        productQuantity = quantity;
        updatePrice();
      });
    });

    if (!qtyHeading) {
      container.classList.add('no-heading');
    } else {
      container.dataset.heading = qtyHeading;
    }

    // const prevQuantity = document.querySelector('#mr-div-embedded-prp-vd-page');
    // prevQuantity.parentNode.insertBefore(container, prevQuantity);
    newContainer.appendChild(container);
  }

  function updatePrice() {
    const maxSubDiscount = getCurrentSubscriptionDiscount();
    const totalDiscountMultiplier = getTotalDiscountMultiplier(maxSubDiscount);
    const price = fixFinalPrice(productPrice * totalDiscountMultiplier * productQuantity);
    const formattedPrice = formatMoney(price);

    buttonPrice.innerText = formattedPrice;

    const originalPrice = productPrice * productQuantity;
    const formattedOriginalPrice = formatMoney(originalPrice);

    if (originalPriceItem) {
      originalPriceItem.innerText = formattedOriginalPrice;
    }
    if (finalPriceItem) {
      finalPriceItem.innerText = price == originalPrice ? '' : formattedPrice;
    }

    updatePricePerItem(productPrice * totalDiscountMultiplier);

    if (!originalPriceItem && !finalPriceItem && price != originalPrice) {
      buttonPrice.innerHTML = `<span class="final">${formattedPrice}</span><span class="original">${formattedOriginalPrice}</span>`;
    }
  }

  function updatePricePerItem(finalPrice) {
    if (!pricePerItemItem || !itemsInPackCount) {
      return;
    }
    pricePerItemItem.innerText = formatMoney(finalPrice / itemsInPackCount);
    if (pricePerItemItem.parentElement.classList.contains('hidden')) {
      pricePerItemItem.parentElement.classList.remove('hidden');
    }
  }

  function fixFinalPrice(price) {
    console.log('Fixing final price:', price);

    if (typeof predictedDiscount != 'string' && !predictedDiscount.length) {
      return price;
    }

    if (predictedDiscount.length == 0) {
      return price;
    }

    console.log('Predicted discount:', predictedDiscount);

    try {
      const discountValue = parseFloat(predictedDiscount.match(/-?\d+(\.\d+)?/)[0]);

      if (predictedDiscount.includes('%')) {
        return price * (1 - discountValue / 100);
      } else if (predictedDiscount.includes('$')) {
        return price - discountValue;
      }
      return price;
    } catch (error) {
      console.error('Error parsing predicted discount:', error);
    }

    return price;
  }

  function setVariationPrice(variationId) {
    const price = parseInt(priceByVariant.find((item) => item.id == variationId)?.price, 10) / 100 || 0;

    if (price) {
      productPrice = price;
    } else {
      productPrice = simpleProductPrice;
    }
  }

  function getTotalDiscountMultiplier(subDiscount = subscriptionDiscount, qtyDiscount = quantityDiscount) {
    return 1 - subDiscount - qtyDiscount + subDiscount * qtyDiscount;
  }

  function extractText(input) {
    return input.replace(/^[0-9]+\s*/, '');
  }

  if (variantIdInput) {
    variantIdInput.addEventListener('change', () => {
      const variantId = variantIdInput.value;

      setTimeout(() => {
        setVariationPrice(variantId);
        updatePrice();
      }, 0);
    });
  }

  function getVariantId() {
    if (variantIdInput) {
      return variantIdInput.value;
    } else {
      console.error('Variant ID input not found');
      return null;
    }
  }

  function prepareDiscountRules(discountRules) {
    const prepareddiscountRules = [];

    for (let i = 0; i < discountRules.length; i++) {
      const min = discountRules[i].count;
      const max = i + 1 < discountRules.length ? discountRules[i + 1].count : Infinity;
      const discount = discountRules[i].discount / 100;

      prepareddiscountRules.push({ min, max, discount });
    }

    window.discountRules = prepareddiscountRules;
  }

  function getCurrentSubscriptionDiscount(forceGet = false) {
    const subscriptionPlan = document.getElementById('product-subscription-plan');
    if (!subscriptionPlan) {
      return 0;
    }
    const isSubscriptionSelected = document.getElementById('subscription-box-checkbox')?.checked;

    if (!isSubscriptionSelected && !forceGet) {
      return 0;
    }

    const selectedOption = subscriptionPlan.options[subscriptionPlan.selectedIndex];
    const selectedPriceAdjustments = selectedOption.dataset.priceAdjustments;

    if (!selectedPriceAdjustments) {
      return 0;
    }
    const priceAdjustments = JSON.parse(selectedPriceAdjustments);

    if (!priceAdjustments) {
      return 0;
    }
    const valueType = priceAdjustments.value_type;
    const value = priceAdjustments.value;

    if (valueType === 'percentage' && value) {
      return value / 100; // Convert percentage to decimal
    }

    return 0;
  }

  document.getElementById('product-subscription-plan')?.addEventListener('change', onSubscriptionBoxChange);
  document.getElementById('subscription-box-checkbox')?.addEventListener('change', onSubscriptionBoxChange);

  function onSubscriptionBoxChange() {
    const currentPlanType = document.getElementById('subscription-box-checkbox')?.checked ? 'subscription' : 'one-time';

    updatePrice();
    updateCurrentPlan(currentPlanType);
    maybeSetSellingPlanInput(currentPlanType);

    const method = currentPlanType != 'subscription' ? 'setAttribute' : 'removeAttribute';
    document.getElementById('product-subscription-plan')[method]('disabled', 'disabled');
  }

  if (document.getElementById('subscription-box-checkbox')) {
    onSubscriptionBoxChange();
  }
  // });

  function updateCurrentPlan(currentPlanType) {
    if (currentPlanType === 'subscription') {
      const currentPlanId = document.getElementById('product-subscription-plan')?.value;
      if (currentPlanId) {
        //update url param selling_plan
        const url = new URL(window.location.href);
        url.searchParams.set('selling_plan', currentPlanId);
        window.history.replaceState({}, '', url.toString());
      }
    } else {
      // Remove the selling_plan parameter from the URL if not a subscription
      const url = new URL(window.location.href);
      url.searchParams.delete('selling_plan');
      window.history.replaceState({}, '', url.toString());
    }
  }

  function maybeSetSellingPlanInput(currentPlanType) {
    const form = productForm.querySelector('form');

    if (!form) {
      console.error('Form not found in product form');
      return;
    }

    let sellingPlanInput = form.querySelector('input[name="selling_plan"]');

    if (sellingPlanInput) {
      sellingPlanInput.remove();
    }

    if (currentPlanType !== 'subscription') {
      return;
    }

    const value = document.getElementById('product-subscription-plan')?.value || '';

    if (!value) {
      return;
    }

    sellingPlanInput = document.createElement('input');
    sellingPlanInput.type = 'hidden';
    sellingPlanInput.name = 'selling_plan';
    sellingPlanInput.id = 'selling_plan';
    form.appendChild(sellingPlanInput);

    setTimeout(() => {
      const originalDescriptor = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value');

      Object.defineProperty(sellingPlanInput, 'value', {
        get() {
          return originalDescriptor.get.call(this);
        },
        set(value) {
          if (currentPlanType === 'subscription' && !value) {
            console.error('Cannot set selling plan value when no subscription plan is selected');
            return;
          }
          originalDescriptor.set.call(this, value);
        },
      });

      sellingPlanInput.value = value;
    }, 0);
  }

  fetch('https://api.monkcommerce.app/app/offer', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      source: 'product_page',
      variantsWithQuantity: [
        {
          sp_variant_id: +getVariantId(),
          quantity: 1,
        },
      ],
      shop_url: Shopify.shop,
      offerType: 'vd',
    }),
  })
    .then((response) => response.json())
    .then((json) => {
      const options = json?.offer?.vdOptions || [];
      const discountRules = [];

      options.forEach((option) => {
        const minQuantity = option.minValue || 1;
        const discount = option.discountValue || 0;

        discountRules.push({
          count: minQuantity,
          discount: discount, // Convert percentage to decimal
        });
      });

      prepareDiscountRules(discountRules);
      renderQuantitySelector();
    })
    .catch((error) => {
      console.error('Error fetching offer:', error);
    });

  updatePrice();
}
